import React from 'react';

import { PageFilters } from '@modules/shared/organisms';
import { useCurrentUser } from '@modules/user/hooks';
import { useSchoolsTableFiltersQuery } from '@modules/schools/hooks';
import { UserGrantActionToken, UserGrantCategoryToken } from '@modules/types/graphql';
import { ToolbarFilters } from './toolbar-filters';
import { DrawerFilters } from './drawer-filters';

const initialFilters = {
    shortName: '',
    locationRegionId: '',
    locationId: '',
    number: '',
};

const SchoolsListFilters = (): React.ReactElement => {
    const { currentUser } = useCurrentUser();
    const { schoolGrants } = currentUser.can({
        [UserGrantCategoryToken.school]: [UserGrantActionToken.search, UserGrantActionToken.filter],
    });

    const { filters: queryFilters } = useSchoolsTableFiltersQuery();

    return (
        <PageFilters
            queryFilters={queryFilters}
            initials={initialFilters}
            drawerFiltersKeys={['locationRegionId', 'locationId', 'number']}
        >
            <ToolbarFilters
                canSearch={schoolGrants.canSearch}
                hideDrawerFilterButton={!schoolGrants.canFilter}
            />

            {schoolGrants.canFilter ? <DrawerFilters /> : null}
        </PageFilters>
    );
};

export { SchoolsListFilters };
